import React, { Suspense } from "react";
import Topbar from "./Topbar";
import TopDialog from "./TopDialog";

const loading = () => <div className=""></div>;

const DefaultLayout = ({ children = null }) => {
  return (
    <>
      <Topbar />
      <TopDialog />
      <Suspense fallback={loading()}>{children}</Suspense>
    </>
  );
};

export default DefaultLayout;
